export const getLinkTypeOrTemplate = (targets, options, localLinkTypeOrTemplate) => localLinkTypeOrTemplate || document.documentElement.dataset.locatorTarget || options.getOptions().templateOrTemplateId || Object.entries(targets)[0][0];
export function linkTemplateUrl(targets, options, localLinkTypeOrTemplate) {
  const templateOrType = getLinkTypeOrTemplate(targets, options, localLinkTypeOrTemplate);
  const target = targets[templateOrType];

  if (target) {
    return target.url;
  }

  return templateOrType;
}